/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: unified
 */
import React from 'react';
import { ActivityIndicator, StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { spacing } from '../../shared/theme/spacing';
import { ticketColors, ticketFonts } from '../../shared/theme/ticketColors';
import { colors } from '../../shared/theme/colors';
import { PaperSheet } from '../../shared/ticket/PaperSheet';
import { TicketButton } from '../../shared/ticket/TicketButton';

type Props = {
  onUploadPress: () => void;
  onDismiss: () => void;
  dismissing?: boolean;
};

export function OrganizationIdentityNudgeCard({ onUploadPress, onDismiss, dismissing }: Props) {
  return (
    <PaperSheet padded testID="organization.logo.nudge.card">
      <View style={styles.row}>
        <View style={styles.iconWrap}>
          <Ionicons name="image-outline" size={22} color={ticketColors.gold} />
        </View>
        <View style={styles.copy}>
          <Text style={styles.title}>Sumá el logo de tu negocio</Text>
          <Text style={styles.body}>
            Lo heredan las sucursales que no tienen logo propio. También se ve arriba y en la tienda online.
          </Text>
          <View style={styles.actions}>
            <TicketButton
              variant="gold"
              label="Subir logo"
              onPress={onUploadPress}
              testID="organization.logo.nudge.upload"
            />
            <TouchableOpacity
              onPress={onDismiss}
              disabled={dismissing}
              accessibilityRole="button"
              accessibilityLabel="Después"
              testID="organization.logo.nudge.dismiss"
              style={styles.laterBtn}
            >
              {dismissing ? (
                <ActivityIndicator size="small" color={ticketColors.ink2} />
              ) : (
                <Text style={styles.laterLabel}>Después</Text>
              )}
            </TouchableOpacity>
          </View>
        </View>
      </View>
    </PaperSheet>
  );
}

const styles = StyleSheet.create({
  row: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: spacing.md,
  },
  iconWrap: {
    width: 44,
    height: 44,
    borderRadius: 12,
    backgroundColor: ticketColors.brandSoft,
    alignItems: 'center',
    justifyContent: 'center',
    borderWidth: StyleSheet.hairlineWidth,
    borderColor: ticketColors.gold,
  },
  copy: {
    flex: 1,
    minWidth: 0,
    gap: spacing.xs,
  },
  title: {
    fontFamily: ticketFonts.sans,
    fontWeight: '700',
    fontSize: 15,
    color: colors.textPrimary,
  },
  body: {
    fontFamily: ticketFonts.sans,
    fontSize: 13,
    lineHeight: 18,
    color: colors.textSecondary,
  },
  actions: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: spacing.sm,
    marginTop: spacing.xs,
  },
  laterBtn: {
    paddingVertical: spacing.sm,
    paddingHorizontal: spacing.sm,
    minHeight: 40,
    justifyContent: 'center',
  },
  laterLabel: {
    fontFamily: ticketFonts.sans,
    fontSize: 14,
    fontWeight: '600',
    color: ticketColors.ink2,
  },
});
